import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';
import styled from 'styled-components';

import { isEmpty } from 'lodash';
import { useTranslation } from '@lt/localization';

import { getFiltersFromUrl } from '../../../../utils';

const Styles = {
  position: 'relative',
  flexDirection: 'column',
  display: 'flex',
  width: '100vw',
  height: '100vh',
  margin: 0,
  padding: 0,
  zIndex: 9999,
};

export const Container = (props) => {
  const { children, isMobile, isOpen, onCancel, clearFilters, cancelFilters } =
    props;
  const hasFilters = !isEmpty(getFiltersFromUrl());

  const { t } = useTranslation();

  const handleCancel = () => {
    cancelFilters();

    if (!onCancel) return;
    onCancel();
  };

  return isMobile ? (
    <Modal
      open={isOpen}
      styles={{ modal: Styles, overlay: { padding: 0, zIndex: 9999 } }}
      showCloseIcon={false}
      onClose={handleCancel}
    >
      <StyledWrapper>
        <StyledCancel type="button" onClick={handleCancel}>
          {t('filters.panel.cancel')}
        </StyledCancel>

        {hasFilters && (
          <StyledClear type="button" onClick={clearFilters}>
            {t('filters.clearbutton.desktop')}
          </StyledClear>
        )}

        {children}
      </StyledWrapper>
    </Modal>
  ) : (
    <div>{children}</div>
  );
};

const StyledWrapper = styled.div`
  position: relative;
  padding-top: 40px;
  background-color: #fff;
`;

const StyledButton = styled.button`
  position: absolute;
  top: 10px;
  font-size: 16px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.blue};
  background: transparent;

  border: none;

  cursor: pointer;
`;

const StyledCancel = styled(StyledButton)`
  left: 8px;
`;

const StyledClear = styled(StyledButton)`
  right: 8px;
`;

Container.propTypes = {
  children: PropTypes.shape({}).isRequired,
  isMobile: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  containerRef: PropTypes.shape({}).isRequired,
};
